import { LINEUPS_FORMATION_CONFIG } from '../constants';
export const isPlayersFormationComplete = (formationUsed, players) => {
    if (!Object.keys(LINEUPS_FORMATION_CONFIG).includes(formationUsed))
        return false;
    const formationList = LINEUPS_FORMATION_CONFIG[formationUsed];
    for (const playersRow of formationList) {
        for (const formationPlaced of playersRow) {
            const playerData = players.find((player) => player.formationPlace === formationPlaced);
            if (!playerData)
                return false;
        }
    }
    return true;
};
